// Inline rupee mark (SVG). The site's latin font subset has no ₹ (U+20B9), so the
// Unicode character falls back to a mismatched system font — visible mostly on bold
// prices. This SVG scales with the surrounding text (em units) and uses currentColor,
// so the rupee matches the digits in any size/colour. Drop it in place of "₹":
//   <Rupee />{amount}
const Rupee = ({ className = "" }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    className={`inline-block align-[-0.1em] w-[0.62em] h-[0.82em] ${className}`}
  >
    <path d="M6 3h12" />
    <path d="M6 8h12" />
    <path d="M6 13l8.5 8" />
    <path d="M6 13h3" />
    <path d="M9 13c6.667 0 6.667-10 0-10" />
  </svg>
);

export default Rupee;
